import React from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import UsersStatsRow from '../../UsersMgmt/UsersStatsRow';
import UsersIndexCard from '../../UsersMgmt/UsersIndexCard';

export default function UsersPage(props) {
	return (
		<div>
			<Breadcrumb
				pageName={I18n.t('admin.users')}
				category={I18n.t('admin.users')}
			/>
			<UsersIndexCard
				public_id={props.public_id}
				iam_get_users_endpoint={props.iam_get_users_endpoint}
				iam_get_user_profile_endpoint={props.iam_get_user_profile_endpoint}
				iam_update_user_profile_endpoint={
					props.iam_update_user_profile_endpoint
				}
				iam_get_user_roles_endpoint={props.iam_get_user_roles_endpoint}
				iam_send_invitations_endpoint={props.iam_send_invitations_endpoint}
				permissionsHelper={props.permissionsHelper}
			/>
		</div>
	);
}
